import { useLocation } from "wouter";
import { useEffect } from "react";
import { useTheme } from "next-themes";

// Paths that always stay in light mode (legal/utility pages where dark may not
// have been audited). Landing "/" is NOT here so the marketing home supports dark.
const ALWAYS_LIGHT_PATHS = [
  "/register",
  "/register-wizard",
  "/auth",
  "/forgot-password",
  "/reset-password",
  // "/activate" tolto: la pagina usa i token del tema (bg-background,
  // text-foreground, border-border), quindi il dark e' gia' corretto e
  // forzarla chiara la lasciava bianca in mezzo a un'app scura — proprio nel
  // primo momento in cui l'utente entra nell'app.
];

export function ForceLightTheme() {
  const [location] = useLocation();
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    const isLightOnly = ALWAYS_LIGHT_PATHS.includes(location);

    const root = document.documentElement;
    if (isLightOnly) {
      root.classList.add("force-light");
    } else {
      root.classList.remove("force-light");
    }
  }, [location, resolvedTheme]);

  return null;
}
